package com.yogaaicoach.pages.workout.workoutOverview.ui

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.pages.workout.data.WorkoutService
import com.yogaaicoach.pages.workout.data.models.Exercise
import com.yogaaicoach.pages.workout.data.models.FocusAreaDataNarrowed
import com.yogaaicoach.pages.workout.data.models.WorkoutData
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

// TODO maybe separate this viewmodel into 2 and just keep in some service the shared data
@OptIn(ExperimentalUuidApi::class)
class WorkoutOverviewViewModel(
    private val workoutService: WorkoutService,
    private val applicationScope: CoroutineScope
) : ViewModel() {
    val isPageLoaded: MutableState<Boolean> = mutableStateOf(false)

    private val _workoutData = MutableStateFlow<WorkoutData?>(null)
    val workoutData: StateFlow<WorkoutData?> = _workoutData

    private val _nextExercise = MutableStateFlow<Exercise?>(null)
    val nextExercise: StateFlow<Exercise?> = _nextExercise

    private val _focusAreas = MutableStateFlow<List<FocusAreaDataNarrowed>>(emptyList())
    val focusAreas: StateFlow<List<FocusAreaDataNarrowed>> = _focusAreas

    private val _isPageLoadedFlow = MutableStateFlow(false)
    val isPageLoadedFlow: StateFlow<Boolean> = _isPageLoadedFlow.asStateFlow()

    private var isLoading = false // To avoid recomposition to cause run init multiple times
    private var isPortraitView = false

    fun init(workoutGuid: Uuid, isPortraitView: Boolean, isUpdate: Boolean) {
        if (!isPageLoaded.value && !isLoading) {
            isLoading = true
            this.isPortraitView = isPortraitView
            viewModelScope.launch {
                val workoutDataDeferred = async { workoutService.getWorkoutData(workoutGuid, isUpdate) }
                val focusAreasDeferred = async { workoutService.getFocusAreas(workoutGuid) }
                _workoutData.value = workoutDataDeferred.await()
                _focusAreas.value = focusAreasDeferred.await()?.selected ?: emptyList()
                isPageLoaded.value = true
                _isPageLoadedFlow.value = true

                isLoading = false
                loadFirstExerciseMedia()
            }
        }
    }

    private fun loadFirstExerciseMedia() {
        val firstExercise = workoutData.value?.exercises?.first()
        _nextExercise.value = workoutData.value?.exercises?.firstOrNull { !it.isCompleted }
        if (firstExercise != null) {
            // TODO probably makes sense to download first mediaUrls here
        }
    }

    fun reset() {
        isPageLoaded.value = false
        _isPageLoadedFlow.value = false
        _workoutData.value = null
        _nextExercise.value = null
        _focusAreas.value = emptyList()
        isLoading = false
    }

    fun completeWorkout(onWorkoutCompletedNavigation: () -> Unit, workoutGuid: Uuid) {
        applicationScope.launch {
            workoutService.completeWorkout(workoutGuid)
        }
        onWorkoutCompletedNavigation()
    }
}